import Select from 'react-select';

import CountUp from 'react-countup';

import Descarga from '../../../components/Descarga';

const customStyles =
{
    control: (styles) =>
    ({
        ...styles,
        borderRadius: '0.75rem',
    })
}

const PesqueriaNuevoV1Page = () =>
{
    const especiesNuevo =
    [
        {
            'value': 'todas_las_especies', 'label': 'Especie: Todas las especies'
        },
        {
            'value': 'anchoveta', 'label': 'Especie: Anchoveta'
        },
        {
            'value': 'sardina_comun', 'label': 'Especie: Sardina común'
        },
        {
            'value': 'sardina_austral', 'label': 'Especie: Sardina austral'
        },
        {
            'value': 'jurel', 'label': 'Especie: Jurel'
        },
        {
            'value': 'caballa', 'label': 'Especie: Caballa'
        },
        {
            'value': 'merluza_comun', 'label': 'Especie: Merluza común'
        },
        {
            'value': 'merluza_austral', 'label': 'Especie: Merluza austral'
        },
        {
            'value': 'merluza_de_cola', 'label': 'Especie: Merluza de cola'
        },
        {
            'value': 'congrio_dorado', 'label': 'Especie: Congrio dorado'
        },
        {
            'value': 'congrio_negro', 'label': 'Especie: Congrio negro'
        },
        {
            'value': 'congrio_colorado', 'label': 'Especie: Congrio colorado'
        },
        {
            'value': 'reineta', 'label': 'Especie: Reineta'
        },
        {
            'value': 'cojinoba_del_norte', 'label': 'Especie: Cojinoba del norte'
        },
        {
            'value': 'pejegallo', 'label': 'Especie: Pejegallo'
        },
        {
            'value': 'raya', 'label': 'Especie: Raya'
        },
        {
            'value': 'albacora', 'label': 'Especie: Albacora'
        },
        {
            'value': 'pez_espada', 'label': 'Especie: Pez espada'
        },
        {
            'value': 'langostino_colorado', 'label': 'Especie: Langostino colorado'
        },
        {
            'value': 'langostino_amarillo', 'label': 'Especie: Langostino amarillo'
        },
        {
            'value': 'camaron_nailon', 'label': 'Especie: Camarón nailon'
        },
        {
            'value': 'Camaron_de_roca', 'label': 'Especie: Camarón de roca'
        },
        {
            'value': 'jaiba', 'label': 'Especie: Jaiba'
        },
        {
            'value': 'centolla', 'label': 'Especie: Centolla'
        },
        {
            'value': 'centollon', 'label': 'Especie: Centollón'
        },
        {
            'value': 'loco', 'label': 'Especie: Loco'
        },
        {
            'value': 'erizo', 'label': 'Especie: Erizo'
        },
        {
            'value': 'ostion_del_norte', 'label': 'Especie: Ostión del norte'
        },
        {
            'value': 'almeja', 'label': 'Especie: Almeja'
        },
        {
            'value': 'chorito', 'label': 'Especie: Chorito'
        },
        {
            'value': 'navajuela', 'label': 'Especie: Navajuela'
        },
        {
            'value': 'jibia', 'label': 'Especie: Jibia'
        }
    ];

    const añosNuevo =
    [
        {
            'value': 2025, 'label': 2025
        },
        {
            'value': 2024, 'label': 2024
        },
        {
            'value': 2023, 'label': 2023
        },
        {
            'value': 2022, 'label': 2022
        },
        {
            'value': 2021, 'label': 2021
        },
        {
            'value': 2020, 'label': 2020
        },
        {
            'value': 2019, 'label': 2019
        },
        {
            'value': 2018, 'label': 2018
        },
        {
            'value': 2017, 'label': 2017
        },
        {
            'value': 2016, 'label': 2016
        },
        {
            'value': 2015, 'label': 2015
        },
        {
            'value': 2014, 'label': 2014
        },
        {
            'value': 2013, 'label': 2013
        },
        {
            'value': 2012, 'label': 2012
        },
        {
            'value': 2011, 'label': 2011
        },
        {
            'value': 2010, 'label': 2010
        },
        {
            'value': 2009, 'label': 2009
        },
        {
            'value': 2008, 'label': 2008
        },
        {
            'value': 2007, 'label': 2007
        },
        {
            'value': 2006, 'label': 2006
        },
        {
            'value': 2005, 'label': 2005
        },
        {
            'value': 2004, 'label': 2004
        },
        {
            'value': 2003, 'label': 2003
        },
        {
            'value': 2002, 'label': 2002
        },
        {
            'value': 2001, 'label': 2001
        },
        {
            'value': 2000, 'label': 2000
        },
        {
            'value': 1999, 'label': 1999
        },
        {
            'value': 1998, 'label': 1998
        },
        {
            'value': 1997, 'label': 1997
        },
        {
            'value': 1996, 'label': 1996
        },
        {
            'value': 1995, 'label': 1995
        },
        {
            'value': 1994, 'label': 1994
        },
        {
            'value': 1993, 'label': 1993
        },
        {
            'value': 1992, 'label': 1992
        },
        {
            'value': 1991, 'label': 1991
        },
        {
            'value': 1990, 'label': 1990
        },
        {
            'value': 1989, 'label': 1989
        },
        {
            'value': 1988, 'label': 1988
        },
        {
            'value': 1987, 'label': 1987
        },
        {
            'value': 1986, 'label': 1986
        },
        {
            'value': 1985, 'label': 1985
        },
        {
            'value': 1984, 'label': 1984
        },
        {
            'value': 1983, 'label': 1983
        },
        {
            'value': 1982, 'label': 1982
        },
        {
            'value': 1981, 'label': 1981
        },
        {
            'value': 1980, 'label': 1980
        },
        {
            'value': 1979, 'label': 1979
        },
        {
            'value': 1978, 'label': 1978
        },
        {
            'value': 1977, 'label': 1977
        },
        {
            'value': 1976, 'label': 1976
        },
        {
            'value': 1975, 'label': 1975
        },
        {
            'value': 1974, 'label': 1974
        },
        {
            'value': 1973, 'label': 1973
        },
        {
            'value': 1972, 'label': 1972
        },
        {
            'value': 1971, 'label': 1971
        },
        {
            'value': 1970, 'label': 1970
        },
        {
            'value': 1969, 'label': 1969
        },
        {
            'value': 1968, 'label': 1968
        },
        {
            'value': 1967, 'label': 1967
        },
        {
            'value': 1966, 'label': 1966
        },
        {
            'value': 1965, 'label': 1965
        },
        {
            'value': 1964, 'label': 1964
        }
    ];

    const regionesNuevo =
    [
        {
            'value': 'todas_las_regiones', 'label': 'Región: Todas las regiones'
        },
        {
            'value': 'arica_parinacota', 'label': 'Región: Arica y Parinacota'
        },
        {
            'value': 'tarapaca', 'label': 'Región: Tarapacá'
        },
        {
            'value': 'antofagasta', 'label': 'Región: Antofagasta'
        },
        {
            'value': 'atacama', 'label': 'Región: Atacama'
        },
        {
            'value': 'coquimbo', 'label': 'Región: Coquimbo'
        },
        {
            'value': 'valparaiso', 'label': 'Región: Valparaíso'
        },
        {
            'value': 'o-higgins', 'label': 'Región: O’Higgins'
        },
        {
            'value': 'maule', 'label': 'Región: Maule'
        },
        {
            'value': 'ñuble', 'label': 'Región: Ñuble'
        },
        {
            'value': 'biobio', 'label': 'Región: Biobío'
        },
        {
            'value': 'la_araucania', 'label': 'Región: La Araucanía'
        },
        {
            'value': 'los_rios', 'label': 'Región: Los Ríos'
        },
        {
            'value': 'los_lagos', 'label': 'Región: Los Lagos'
        },
        {
            'value': 'magallanes', 'label': 'Región: Magallanes'
        }
    ];

    const estadisticasNuevo =
    [
        {
            "titulo": "Viajes de pesca",
            "data": 4060125
        },
        {
            "titulo": "Años de datos",
            "data": 61
        },
        {
            "titulo": "Individuos muestreados",
            "data": 84727952
        },
        {
            "titulo": "Regiones cubiertas",
            "data": 15
        }
    ];

    const operacionNuevo =
    [
        {
            'titulo': 'Captura',
            'data': 12540,
            'registros':
            [
                {
                    'titulo': 'Arrastre',
                    'total': 4200
                },
                {
                    'titulo': 'Cerco',
                    'total': 3100
                },
                {
                    'titulo': 'Espinel',
                    'total': 2050
                },
                {
                    'titulo': 'Enmalle',
                    'total': 1420
                },
                {
                    'titulo': 'Palangre',
                    'total': 980
                },
                {
                    'titulo': 'Buceo',
                    'total': 520
                },
                {
                    'titulo': 'Trampa',
                    'total': 270
                }
            ]
        },
        {
            'titulo': 'CIAMT',
            'data': 4210,
            'registros':
            [
                {
                    'titulo': 'Interacciones aves',
                    'total': 2340
                },
                {
                    'titulo': 'Mamíferos marinos',
                    'total': 1870
                }
            ]
        },
        {
            'titulo': 'IOE',
            'data': 1870,
            'registros':
            [
                {
                    'titulo': 'Fauna acompañante',
                    'total': 1120
                },
                {
                    'titulo': 'Eventos operacionales',
                    'total': 750
                }
            ]
        },
        {
            'titulo': 'Proporción de especies',
            'data': 3120,
            'registros':
            [
                {
                    'titulo': 'Merluza común',
                    'total': 1820
                },
                {
                    'titulo': 'Jurel',
                    'total': 840
                },
                {
                    'titulo': 'Otras',
                    'total': 460
                }
            ]
        },
        {
            'titulo': 'Muestreo de longitud',
            'data': 8450,
            'registros':
            [
                {
                    'titulo': 'Machos',
                    'total': 4120
                },
                {
                    'titulo': 'Hembras',
                    'total': 4330
                }
            ]
        },
        {
            'titulo': 'Muestreo biológico',
            'data': 2980,
            'registros':
            [
                {
                    'titulo': 'Madurez',
                    'total': 1420
                },
                {
                    'titulo': 'Peso gonadal',
                    'total': 1560
                }
            ]
        }
    ];

    return (
        <div className="container-fluid ps-0 pe-0 pt-0">
            <div className="row row-cols-1 g-1 mb-2 buscador-avanzado bg-cover ps-1 pe-1 ps-lg-5 pe-lg-5">
                <div className="row row-cols-6 g-2 z-2">
                    <div className="col-12 text-center">
                        <h1 className="text-primary mb-3 fs-2">Buscador de Datos Pesqueros</h1>
                        <h2 className="text-primary mb-4 fs-4">Plataforma institucional para la exploración y descarga de datos pesqueros y biológicos (1964-2025)</h2>
                    </div>
                </div>
                <div className="row pt-3 ps-1 pe-1 ps-lg-4 pe-lg-4">
                    <div className="col">
                        <div className="card h-100 border-0 bg-transparent">
                            <div className="card-body">
                                <h6 className="fw-bold text-muted text-uppercase">Filtros de exploración</h6>
                                <div className="row g-2 justify-content-md-center">
                                    <div className="col-12 col-md-4">
                                        <Select
                                            isMulti
                                            name="selector"
                                            options={especiesNuevo}
                                            placeholder="Seleccione al menos una especie (*)"
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            styles={customStyles}
                                        />
                                    </div>
                                    <div className="col-4 col-md-4">
                                        <Select
                                            isMulti
                                            name="selector"
                                            options={añosNuevo}
                                            placeholder="Seleccione al menos un año (*)"
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            styles={customStyles}
                                        />
                                    </div>
                                    <div className="col-4 col-md-4">
                                        <Select
                                            isMulti
                                            name="selector"
                                            options={regionesNuevo}
                                            placeholder="Seleccione al menos un puerto (*)"
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            styles={customStyles}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fade-in-animation">
                    <div className="row g-1 mt-1 mb-2 ps-5 pe-5">
                        <div className="col-12">
                            <div className="card-group shadow">

                                {
                                    estadisticasNuevo.map((estadistica, index) =>
                                    (
                                        <div key={index} className="card bg-transparent">
                                            <div className="card-body text-center">
                                                <h2 className="fw-bold azulIfop estadisticas-numero">
                                                    <CountUp separator="." end={estadistica.data} duration={3} />
                                                </h2>
                                                <h2 className="text-muted estadisticas-texto">{estadistica.titulo}</h2>
                                            </div>
                                        </div>
                                    ))
                                }

                            </div>
                        </div>
                    </div>
                </div>
                <div className="fade-in-animation">
                    <div className="row g-4 my-4 ps-5 pe-5">
                    <h6 className="fw-bold text-muted text-uppercase">Operación / Observación</h6>

                        {
                            operacionNuevo.map((estadistica, index) =>
                            (
                                <div key={index} className="col-4 mt-2">
                                    <div className="card border-0 border-top border-primary shadow" style={{ borderWidth: '4px' }}>
                                        <div className="card-header" id="headingOne">
                                            <h5 className="fw-bold fs-6">{estadistica.titulo}</h5>
                                            <div className="d-flex justify-content-between">
                                                <span>Total registros</span>
                                                <span>{estadistica.data.toLocaleString('es-CL')}</span>
                                            </div>
                                        </div>
                                        <div className="card-body">

                                            {
                                                estadistica.registros.map((registro, index) =>
                                                (
                                                    <div key={index} className="d-flex justify-content-between">
                                                        <span>{registro.titulo}</span>
                                                        <span>{registro.total.toLocaleString('es-CL')}</span>
                                                    </div>
                                                ))
                                            }

                                        </div>
                                    </div>
                                </div>
                            ))
                        }

                    </div>
                </div>
            </div>
            <Descarga />
        </div>
    )
}

export default PesqueriaNuevoV1Page;
